import { makeStyles } from "@fluentui/react";

export const useMakeStyle = makeStyles({
    body: {
        height: 'calc(100% - 5rem)',
        // backgroundColor: "black"
    }
});